import { ConnectionRefusedError } from "../domain/error/ConnectionRefusedError";
import { ApiError } from "./APIError";
import {
  vectiAppApiUrl,
  vectiAppAuth0Domain,
  vectiAppAuth0ClientId,
  vectiAppAuth0RedirectUrl,
} from "./Config";
import { Auth0Client } from "@auth0/auth0-spa-js";

export abstract class APIRepository {
  private readonly url: string;
  private static auth0 = new Auth0Client({
    domain: vectiAppAuth0Domain(), //TODO: Parametrizar
    clientId: vectiAppAuth0ClientId(),
    authorizationParams: {
      redirect_uri: vectiAppAuth0RedirectUrl(), //TODO: Parametrizar
      audience: "https://" + vectiAppAuth0Domain() + "/api/v2/", //TODO: Parametrizar
    },
  });

  constructor(url: string | null = null) {
    if (url === null) {
      this.url = vectiAppApiUrl();
    } else {
      this.url = url;
    }
  }

  //  This method will be used to make a GET request to the API.
  //  It will take in a URL and an optional query parameters object.
  //  It will return a Promise that will resolve to the data returned by the API.
  //  If the API returns an error, it will reject with the error.
  protected async doGet<TResponse>(
    path: string,
    queryparams: Record<string, string> | null = null,
    url: string = this.url
  ): Promise<TResponse> {
    //console.log("ApiRepository:doGet");

    const params = queryparams
      ? new URLSearchParams(queryparams)
      : new URLSearchParams();
    //console.log("ApiRepository:doGet", path, params.toString(), url);
    const callUrl = new URL(path + "?" + params.toString(), url).toString();
    //console.log("callUrl 1:" + callUrl);
    //console.log("vectiAppAuth0Domain():" + vectiAppAuth0Domain());

    return new Promise<TResponse>((resolve, reject) => {
      APIRepository.auth0
        .getTokenSilently({
          authorizationParams: {
            audience: "https://" + vectiAppAuth0Domain() + "/api/v2/", //TODO: Parametrizar
            scope: "email",
          },
        })
        .then((token: any) => {
          //  console.log("token: ", token);
          //console.log("callUrl X:", callUrl);
          fetch(callUrl, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
            .then((response) => {
              //              console.log("response: " + response.status);


              // console.log("callUrl: " + JSON.stringify(callUrl), "token: " + JSON.stringify(token));


              if (response.ok) {
                //           console.log("item ok " + response.status);
                return response.json();
              } else if (response.status == 404) {
                return response.json();
              } else if (response.status == 500) {
                reject(new ConnectionRefusedError("Connection refused"));

              } else {
                //console.log("error: " + response.statusText + " status:" + response.status + " body:" + JSON.stringify(response.body));
                //   console.log("response api: " + JSON.stringify(response.text()));
                //    console.log("response!: " + JSON.stringify(response));
                reject(new Error("" + response.json()));
                //return response.json();
                //  throw new Error(response.statusText);
              }
            })
            // and return the result data.
            .then((data) => {
              //              console.log("retornando data: " + JSON.stringify(data));
              resolve(data as TResponse);
            })
            .catch((error) => {
              //console.log("error: " + error);
              // Rechazar la promesa en caso de error
              reject(new Error(error));
            });
        })
        .catch((error: any) => {
          //console.log("error Api Respository: " + error);
          reject(new Error(error));
        });
    });
  }

  protected async doPostNew<TRequest, TResponse = void>(
    path: string,
    queryParams: Record<string, string> | null,
    body: TRequest,
    baseUrl: string = this.url
  ): Promise<TResponse> {

    try{
    const urlObject = new URL(path, baseUrl);
    if (queryParams) {
      Object.keys(queryParams).forEach(key => {
        urlObject.searchParams.append(key, queryParams[key]);
      });
    }
    const callUrl = urlObject.toString();


    const token = await APIRepository.auth0.getTokenSilently({
      authorizationParams: {
        audience: "https://" + vectiAppAuth0Domain() + "/api/v2/", //TODO: Parametrizar
        scope: 'email',
      },
    });

    const response = await fetch(callUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });

    console.log("(ApiRepository) doPostNew response:" + JSON.stringify(response));

    if (!response.ok) {
      const errorBody = await response.text(); // Read as text first, then try to parse as JSON
      let parsedErrorBody;
      try {
        parsedErrorBody = JSON.parse(errorBody);
      } catch (e) {
        parsedErrorBody = errorBody; // If not JSON, keep as text
      }
let message;
      try{
        message = JSON.parse(response.statusText);
      }catch(error){
      }
      console.log("message:" + message);
      console.log("JSONmessage:" + JSON.stringify(message));
      console.error(`API Error: ${response.status} ${message}, Body: ${JSON.stringify(parsedErrorBody)}`);
      throw new ApiError(response.status, message, parsedErrorBody);
    }

    if (response.status === 204 || response.headers.get('Content-Length') === '0') {
        return undefined as TResponse; // Cast to TResponse to satisfy the type
    }
    
    // Attempt to parse JSON response
    const data: TResponse = await response.json();
    console.log(`(ApiRepository) doPostNew: API response OK: Status ${response.status}, Data:`, data);
    return data;

 } catch (error) {
    // 6. Centralized error handling
    if (error instanceof ApiError) {
      // Re-throw specific API errors
      throw error;
    } else {
      console.error(`Error in doPostNew: ${error}`);
      if (error instanceof Error) {
        throw new Error(`Failed to perform POST request: ${error.message}`); // Re-throw a generic error or a more specific one
      } else {
        throw new Error(`Failed to perform POST request: ${String(error)}`);
      }
    }
  }


  }

  protected async doPostNoAuth<TRequest, TResponse>(
    path: string,
    queryparams: Record<string, string> | null,
    body: TRequest,
    url: string = this.url
  ): Promise<TResponse>  {
    try{ 
    const params = queryparams
      ? new URLSearchParams(queryparams)
      : new URLSearchParams();
    const callUrl = new URL(path + params.toString(), url).toString();
    const response = await fetch(callUrl, { method: "POST", headers: { Accept: "application/json", "Content-Type": "application/json", }, body: JSON.stringify(body), });
    if (response.ok) {
      const data: TResponse = await response.json();
      console.log("data: " + JSON.stringify(data));
      console.log("response.status: " + response.status);
      return data; // La promesa se resuelve con el objeto TResponse
    } else if (response.status === 404) {
      // Si el estado es 404, se asume un ErrorPersonalizado
      const resp = await response.json();
      const errorData: { code?: string; message?: string } =resp ;
      console.log("resp:" + JSON.stringify(resp));
      // Rechaza la promesa con un Error, cuyo mensaje contendrá el código de error.
      // Asegúrate de que errorData.code exista según tu backend.
      throw new Error(errorData.code || 'UNKNOWN_CUSTOM_ERROR');
    } else {
      // Para otros códigos de estado de error (ej. 500, 400, etc.)
      const errorText: string = await response.text();
      console.log("errorTest:" + errorText);
      throw new Error(`HTTP_ERROR_${response.status}: ${errorText}`);
    }
  }catch(error){
     if (error instanceof TypeError) { // Error de red (ej. servidor no alcanzable)
      throw new Error('NETWORK_ERROR: ' + error.message);
    } else if (error instanceof Error) { // Errores lanzados anteriormente (del 404 o otros HTTP)
      throw error; // Relanza el error ya capturado (código personalizado o HTTP_ERROR)
    } else {
      throw new Error('UNKNOWN_ERROR: ' + String(error));
    }
  }
      
  }

/*
  protected async doPostNoAuth<TRequest>(
    path: string,
    queryparams: Record<string, string> | null,
    body: TRequest,
    url: string = this.url
  ): Promise<void> {

    const params = queryparams
      ? new URLSearchParams(queryparams)
      : new URLSearchParams();
    const callUrl = new URL(path + params.toString(), url).toString();
    return new Promise<void>(async (resolve, reject) => {
      await fetch(callUrl, { method: "POST", headers: { Accept: "application/json", "Content-Type": "application/json", }, body: JSON.stringify(body), })
        .then((response) => {
//          console.log("response X: " + JSON.stringify(response.body));
//          console.log("response2: " + JSON.stringify(response.headers));
          //  console.log("callUrl: " + callUrl);
          if (!response.ok) {
//            console.log("error response API: " + JSON.stringify(response.json) + " status:" + response.status + " body:" + JSON.stringify(response.body));
            reject(Error(response.statusText));
            return;
          } else {
//            console.log("response ok API: " + response.statusText + " status:" + response.status + " body:" + JSON.stringify(response.body));
            //console.log("response ok API JSONX: " + JSON.stringify(response));
          }
//          console.log("respuesta: " + JSON.stringify(response))
          resolve();
        }).then((data) => {
 //         console.log("retornando data: " + JSON.stringify(data));
          resolve(data as void);
        })
    }
    );
  }
*/


  protected async doPost<TRequest, TResponse>(
    path: string,
    queryparams: Record<string, string> | null,
    body: TRequest,
    url: string = this.url
  ): Promise<TResponse> {
    const params = queryparams
      ? new URLSearchParams(queryparams)
      : new URLSearchParams();
    const callUrl = new URL(path + params.toString(), url).toString();
    return APIRepository.auth0
      .getTokenSilently({
        authorizationParams: {
          audience: "https://" + vectiAppAuth0Domain() + "/api/v2/", //TODO: Parametrizar
          scope: "email",
        },
      })
      .then(async (token: any) => {
        const response = await fetch(callUrl, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(body),
        });
        if (!response.ok) {
          //console.log("error response API: " + response.statusText + " status:" + response.status + " body:" + JSON.stringify(response.body));
          throw new Error(response.statusText);
        }

        //console.log("response ok API: " + response.statusText + " status:" + response.status + " body:" + JSON.stringify(response.body));
        //console.log("response ok API JSONX: " + JSON.stringify(response));

        return response.json() as Promise<TResponse>;
      })
      .catch((error: any) => {
        //console.log("error Api Respository: " + error);
        throw error;
      });
  }


  protected async doPostFile<FormData extends globalThis.FormData, TResponse>(
    path: string,
    queryparams: Record<string, string> | null,
    body: FormData,
    url: string = this.url
  ): Promise<TResponse> {
    const params = queryparams
      ? new URLSearchParams(queryparams)
      : new URLSearchParams();
    const callUrl = new URL(path + params.toString(), url).toString();
    //for (const pair of body.entries()) {
      //console.log("body:" + pair[0] + ', ' + pair[1]);
    //}
    //console.log("body.file:" + body.get("file"))
    //console.log("body.filename X:" + (body.get("file") as File).name)




    return APIRepository.auth0
      .getTokenSilently({
        authorizationParams: {
          audience: "https://" + vectiAppAuth0Domain() + "/api/v2/", //TODO: Parametrizar
          scope: "email",
        },
      })
      .then(async (token: any) => {
        const response = await fetch(callUrl, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            //  'Content-Type': 'multipart/form-data'
          },
          body: body,
        });
        if (!response.ok) {
          console.log("error response API: " + response.statusText + " status:" + response.status + " body:" + JSON.stringify(response.body));
          throw new Error(response.statusText);
        }

        //console.log("response ok API: " + response.statusText + " status:" + response.status + " body:" + JSON.stringify(response.body));
        //console.log("response ok API JSONX: " + JSON.stringify(response));

        return response.json() as Promise<TResponse>;
      })
      .catch((error: any) => {
        console.log("error Api Respository: " + error);
        throw error;
      });
  }




}
